import JobWishlistContainer from "../../components/job/Wishlist";

const JobWishlist = () => {
  return <JobWishlistContainer />;
};

export default JobWishlist;
